import { all } from 'redux-saga/effects'

import assessmentQuestion from './containers/assessmentQuestion/sagas'
import addAssessmentQuestion from './containers/addAssessmentQuestion/sagas'
import assessmentTest from './containers/assessmentTest/sagas'
import addAssessmentTest from './containers/addAssessmentTest/sagas'
import addContest from './containers/addContest/sagas'
import contest from './containers/contest/sagas'

export default function* IndexSaga () {
  yield all([
    assessmentQuestion(),
    addAssessmentQuestion(),
    assessmentTest(),
    addAssessmentTest(),
    addContest(),
    contest(),
  ])
}
